/**
 * AsfContentObjectHeaderController is a controller class responsible for managing the header of content objects.
 * It initializes tabs and carousels based on the configuration and content object properties.
 */
class AsfContentObjectHeaderController {
    /**
     * Constructor for AsfContentObjectHeaderController.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} TaskDataService - Service for handling task data.
     * @param {Object} $rootScope - The root scope of the application.
     * @param {Object} ContentObjectRegistryService - Service for registering content objects.
     * @param {Object} $translate - Service for translation.
     * @param {Object} $config - Configuration object.
     */
    constructor($scope, TaskDataService, $rootScope, ContentObjectRegistryService, $translate, $config) {
        if ($config.isExamExport()) return;

        $scope.isCMS = isCMS;
        $scope.rootScope = $rootScope;
        $scope.size = $scope.$parent.$parent.$parent.size;

        $scope.containerObj = $scope.parentScope.$parent.containerObj;

        angular.forEach(ContentObjectRegistryService.registeredContent(), function (group, key) {
            angular.forEach(group.objProperties, function (itm, key) {
                if (!angular.isDefined($scope.parentScope.contentObject)) {
                    return;
                }
                if ($scope.parentScope.contentObject.data.objectType === itm.type) {
                    $scope.objLabel = $translate.instant(itm.label);
                    $scope.objIcon = itm.icon;
                    $scope.objDescription = $translate.instant(itm.description);
                }
            });
        });

        if (typeof $scope.containerObj !== "undefined" && $scope.containerObj.isShowTabs()) {
            this.initializeTabs($scope, TaskDataService);
        }

        if (typeof $scope.containerObj !== "undefined" && $scope.containerObj.isShowCarousels()) {
            this.initializeCarousels($scope, TaskDataService);
        }
    }

    /**
     * Initializes the tabs for the content object.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} TaskDataService - Service for handling task data.
     */
    initializeTabs($scope, TaskDataService) {
        var _taskContext = TaskDataService.fetchContext();

        $scope.tabs = {};
        angular.forEach($scope.containerObj.getTabs(), function (tab, key) {
            var _tabObj = _taskContext.read(tab.content);
            $scope.tabs[tab.content] = _tabObj.getPreferences();
            angular.forEach(_tabObj.getObjects(), function (tabObj, tabObjkey) {
                if (tabObj === $scope.parentScope.contentObject.getUUID()) {
                    $scope.inTab = tab.content;
                }
            });
        });

        $scope.onChangeTab = function () {
            var objTmp;
            var cancelForeach = false;
            angular.forEach($scope.containerObj.getTabs(), function (tab, key) {
                var _tabObj = _taskContext.read(tab.content);
                if (!cancelForeach) {
                    angular.forEach(_tabObj.data.objects, function (tabObj, tabObjkey) {
                        if (tabObj === $scope.parentScope.contentObject.getUUID() && !cancelForeach) {
                            cancelForeach = true;
                            objTmp = tabObj;
                            _tabObj.data.objects.splice(tabObjkey, 1);
                            _tabObj.flagAsDirty();
                        }
                    });
                }

                if (tab.content === $scope.inTab) {
                    _tabObj.data.objects.push($scope.parentScope.contentObject.getUUID());
                    _tabObj.flagAsDirty();
                }
            });
        };
    }

    /**
     * Initializes the carousels for the content object.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} TaskDataService - Service for handling task data.
     */
    initializeCarousels($scope, TaskDataService) {
        var _taskContext = TaskDataService.fetchContext();

        $scope.carousels = {};
        angular.forEach($scope.containerObj.getCarousels(), function (carousel, key) {
            var _carouselObj = _taskContext.read(carousel.content);
            $scope.carousels[carousel.content] = _carouselObj.getPreferences();
            angular.forEach(_carouselObj.getObjects(), function (carouselObj, carouselObjkey) {
                if (carouselObj === $scope.parentScope.contentObject.getUUID()) {
                    $scope.inCarousel = carousel.content;
                }
            });
        });

        $scope.onChangeCarousel = function () {
            var objTmp;
            var cancelForeach = false;
            angular.forEach($scope.containerObj.getCarousels(), function (carousel, key) {
                var _carouselObj = _taskContext.read(carousel.content);
                if (!cancelForeach) {
                    angular.forEach(_carouselObj.data.objects, function (carouselObj, carouselObjkey) {
                        if (carouselObj === $scope.parentScope.contentObject.getUUID() && !cancelForeach) {
                            cancelForeach = true;
                            objTmp = carouselObj;
                            _carouselObj.data.objects.splice(carouselObjkey, 1);
                            _carouselObj.flagAsDirty();
                        }
                    });
                }

                if (carousel.content === $scope.inCarousel) {
                    _carouselObj.data.objects.push($scope.parentScope.contentObject.getUUID());
                    _carouselObj.flagAsDirty();
                }
            });
        };

        $scope.toggled = function (open) {
            if (open) {
                $('.carousel-inner').css('overflow', 'inherit');
            } else {
                $('.carousel-inner').css('overflow', 'hidden');
            }
        };
    }
}

export { AsfContentObjectHeaderController };

/**
 * Registers the AsfContentObjectHeader directive.
 * @param {Object} module - The AngularJS module.
 */
export default function registerAsfContentObjectHeaderDirective(module) {
    module.directive('asfContentObjectHeader', function ($compile) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                parentScope: '=scope',
                size: '@size'
            },
            templateUrl: '/views/ib/cms/CMSContentObjectHeader.html',
            controller: AsfContentObjectHeaderController
        };
    });
}